import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import ApiAccounts from "./pages/ApiAccounts";
import UsersPage from "./pages/UsersPage";
import LogsPage from "./pages/LogsPage";
import Docs from "./pages/Docs";
import BulkIaPage from "./pages/BulkIaPage";

export default function AdminApp() {
    return (
        <AuthProvider>
            <div className="admin-area" data-testid="admin-area">
                <Routes>
                    <Route path="login" element={<Login />} />
                    <Route
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Overview />} />
                        <Route path="contas-api" element={<ApiAccounts />} />
                        <Route path="usuarios" element={<UsersPage />} />
                        <Route path="logs" element={<LogsPage />} />
                        <Route path="ia-massa" element={<BulkIaPage />} />
                        <Route path="ia-massa/:id" element={<BulkIaPage />} />
                        <Route path="documentacao" element={<Docs />} />
                        <Route path="*" element={<Navigate to="/admin" replace />} />
                    </Route>
                </Routes>
            </div>
        </AuthProvider>
    );
}
